import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';

import ChevronLeftNarrowIcon from '../../icons/utility/ChevronLeftNarrow';
import ChevronRightNarrowIcon from '../../icons/utility/ChevronRightNarrow';
import { Row, Col } from '../../base/Grid';

export const SwiperCarouselContainerRow = styled(Row)`
  && {
    width: 100%;
    height: 100%;
    padding-bottom: ${rem(40)};
  }
`;

export const SwiperCarouselSwiperSlide = styled.div`
  display: flex;
  justify-content: center;
`;

export const SwiperCarouselSwiperSlideRow = styled(Row)`
  width: 100%;
  justify-content: center;
`;

export const SwiperCarouselSwiperSlideCol = styled(Col)`
  ${({ theme }) => {
    let thisFlex = '0 100%';
    let thisMaxWidth = '100%';
    if (theme.smallUp()) {
      thisFlex = '0 83.33333333333334%';
      thisMaxWidth = '83.33333333333334%';
    }
    // TODO: not working
    return css`
      flex: ${thisFlex};
      max-width: ${thisMaxWidth};
    `;
  }}
`;

export const SwiperCarouselSwiperPagination = styled.div`
  && {
    width: 100%;
    bottom: 0;
  }
`;

export const SwiperCarouselSwiperNavigation = styled.div`
  ${({ theme }) => css`
    && {
      display: block;
      width: ${rem(17)};
      height: ${theme.smallUp() ? 'unset' : '100%'};
      top: ${theme.smallUp() ? '45%' : 0};
      background-color: ${theme.smallUp() ? 'unset' : 'rgba(255,255,255,0.3)'};
      &::after {
        color: ${theme.colors.neutral.gray41};
        visibility: hidden;
      }
    }
  `}
`;

export const SwiperCarouselSwiperNavigationLeftIcon = styled(ChevronLeftNarrowIcon)`
  ${({ theme }) => css`
    .icon-stroke {
      fill: none; /** TODO: reexamine build-icons to handle svg polyline stroke and fill */
      stroke: ${theme.colors.neutral.gray54};
    }
    :hover {
      .icon-stroke {
        stroke: ${theme.colors.cta.blue};
      }
    }
  `}
`;

export const SwiperCarouselSwiperNavigationRightIcon = styled(ChevronRightNarrowIcon)`
  ${({ theme }) => css`
    .icon-stroke {
      fill: none; /** TODO: reexamine build-icons to handle svg polyline stroke and fill */
      stroke: ${theme.colors.neutral.gray54};
    }
    :hover {
      .icon-stroke {
        stroke: ${theme.colors.cta.blue};
      }
    }
  `}
`;
